import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import { MutableRefObject } from 'react';
import { useTheme } from '@mui/material/styles';

interface DistractionFreeEditorProps {
  editorRef: MutableRefObject<TinyMCEEditor | null>;
  content: string;
  setContent: (content: string) => void;
  placeholder?: string;
  mergeTags?: unknown;
}

export default function DistractionFreeEditor({
  editorRef,
  content,
  setContent,
  placeholder,
  mergeTags,
}: DistractionFreeEditorProps) {
  const theme = useTheme();

  return (
    <>
      <Editor
        apiKey={import.meta.env.VITE_TINYMCE_API_KEY}
        onInit={(_evt, editor) => (editorRef.current = editor)}
        value={content}
        onEditorChange={(newContent) => setContent(newContent)}
        init={{
          skin: theme.palette.mode !== 'dark' ? 'oxide' : 'oxide-dark',
          content_css: theme.palette.mode !== 'dark' ? 'default' : 'dark',
          placeholder: placeholder,
          branding: false,
          height: '100%',
          width: '100%',
          menubar: false,
          toolbar:
            'mergetags image quicktabl hr | bold italic underline strikethrough | forecolor backcolor | link',
          statusbar: false,
          plugins: 'mergetags anchor autolink image link lists media',
          // quickbars_insert_toolbar: 'mergetags image quicktable hr',
          // quickbars_selection_toolbar:
          //   'mergetags bold italic underline strikethrough | forecolor backcolor | link',
          mergetags_prefix: '{|',
          mergetags_suffix: '|}',
          mergetags_list: mergeTags,
          highlight_on_focus: false,
        }}
      />
    </>
  );
}
